import { AsButton, Spacer } from '@adserve/adserve-react-components';
import React, { useEffect, useState } from 'react';
import { DealDiscountPolicy } from '../../../constants/Enums';
import { discountPanelStyle } from './CampaignBriefStyles';
import CustomDiscountsTable from './CustomDiscounts/CustomDiscountsTable';

const CampaignDiscounts = ({
    campaign,
    discountData = [],
    onChange,
    activeRequest = {},
    selectedDealDiscountPolicy,
    onRequestApprovalClick,
    discountApprovalWorkflowId,
    readOnly,
    discountChanged,
    discountRequest
}) => {
    const [effectiveDiscount, setEffectiveDiscount] = useState(0);
    const [discountGiven, setDiscountGiven] = useState();

    useEffect(() => {
        const discount = discountData.reduce(
            (prev, cur) =>
                prev +
                (cur.campaignPercentageValue > 0
                    ? cur.campaignPercentageValue
                    : 0),
            0
        );
        setEffectiveDiscount(discount);
    }, [discountData]);

    const handleRequestApprovalClick = () => {
        if (onRequestApprovalClick) {
            onRequestApprovalClick(effectiveDiscount);
        }
    };

    useEffect(() => {
        const dealDiscountPolicyKey = Object.keys(DealDiscountPolicy).find(
            (key) => DealDiscountPolicy[key].id === selectedDealDiscountPolicy
        );

        setDiscountGiven(DealDiscountPolicy[dealDiscountPolicyKey].text);
    }, [selectedDealDiscountPolicy]);

    return (
        <div style={discountPanelStyle}>
            <span style={{ fontSize: 15, fontWeight: 500, marginBottom: 17 }}>
                {window.translate('Custom Discounts')}
            </span>
            <div style={{ display: 'flex' }}>
                <CustomDiscountsTable
                    campaign={campaign}
                    discountData={discountData}
                    onChange={onChange}
                    readOnly={readOnly}
                    discountGiven={discountGiven}
                    effectiveDiscount={effectiveDiscount}
                    style={{ width: 750 }}
                    activeRequest={activeRequest}
                />
                <Spacer width={59} />
                <div
                    style={{
                        display: discountApprovalWorkflowId && discountData?.some((dd) => dd?.campaignPercentageValue && dd?.campaignPercentageValue <= dd?.percentageValue) ? 'flex' : 'none',
                        flexDirection: 'column',
                        alignItems: 'center',
                        fontSize: 15,
                        fontWeight: 'bold',
                        boxSizing: 'border-box',
                        height: 124,
                        width: 269,
                        border: '1px solid #D7D7D7',
                        borderRadius: 8,
                        marginTop: 38.5
                    }}
                >
                    <div style={{ marginTop: 11 }}>
                        <span>{`${window.translate('Approval Status')}: ${
                            (discountRequest?.state?.stateType === 0 ? 'Requested' : discountRequest?.state?.name) ||
                            window.translate('Not requested')
                        } ${discountChanged ? `(${window.translate('Discount was changed')})` : ''}`}</span>
                    </div>
                    <AsButton
                        style={{
                            fontSize: 15,
                            fontWeight: 'bold',
                            marginTop: 14
                        }}
                        handleClick={handleRequestApprovalClick}
                        disabled={discountRequest?.id || !effectiveDiscount}
                    >
                        {window.translate('Request Approval')}
                    </AsButton>
                </div>
            </div>
        </div>
    );
};

export default CampaignDiscounts;
